'use strict';

import acceptedCookiePolicy from "../../components/onetrust/cookiePolicy";
import buttonsSaveJobs from '../_imports/careers/buttons-saveJobs.common';
import setSavedJobsIcon from './_imports/career/set-saved-jobs-icon';
import facetsTracking from "./_imports/amplitude/facet-tracking.js";
import { waitForDependencies } from "../_imports/utils/utils.common";


waitForDependencies(() => {
    if (typeof (Coveo) !== 'undefined') {
        Coveo.$$(document.body).on("afterComponentsInitialization", function () {
            Coveo.$$(document.body).on("newResultsDisplayed", (e, data) => {
                if ($('#all-integrations-search').length) {
                    if ($('.coveo-query-summary-no-results-string').length) {
                        $(".coveo-results-column").addClass('coveo-website-no-results');
                    } else {
                        $(".coveo-results-column").removeClass('coveo-website-no-results');
                    }
                }

                acceptedCookiePolicy({
                    ifFunctionalCookies: () => {
                        buttonsSaveJobs();
                        setSavedJobsIcon();
                    }
                });

                facetsTracking();
            });
        });
    }
});